import React from 'react';
import { useDispatch } from 'react-redux';
import clsx from 'clsx';
import moment from 'moment';
import PropTypes from 'prop-types';
import _ from 'underscore';
import { makeStyles } from '@mui/styles';
import { IconButton, Tooltip } from '@mui/material';
import DownloadIcon from '@mui/icons-material/Download';
import { DataTable } from 'components';

const useStyles = makeStyles((theme) => ({
	root: {},
	content: {
		padding: 0,
	},
	inner: {
		minWidth: 700,
	},
	nameCell: {
		display: 'flex',
		alignItems: 'center',
	},
	avatar: {
		height: 42,
		width: 42,
		marginRight: theme.spacing(1),
	},
	actions: {
		padding: theme.spacing(1),
		justifyContent: 'flex-end',
	},
	primaryButton: {
		color: theme.palette.primary.main
	}
}));

const AnrNbrTrackingTable = (props) => {
	const { data, ...rest } = props;
	const classes = useStyles();
	const dispatch = useDispatch();

	const _getTableColumns = () => (
		[
			{
				name: 'runDate',
				label: 'Run Date',
				options: {
					display: true,
					filterType: 'textField',
					customBodyRender: (value, tableMeta, updateValue) => <>{moment(value).format('DD-MM-YYYY').toString()}</>
				}
			},
			{
				name: 'siteId',
				label: 'Site Id',
				options: {
					display: true,
					filterType: 'textField',
				}
			},
			{
				name: 'change',
				label: 'Change',
				options: {
					display: true,
					filterType: 'textField',
				}
			},
			{
				name: 'changeCount',
				label: 'Change Count',
				options: {
					display: true,
					filterType: 'textField',
				}
			},
		]
	);

	return (
		<div {...rest} className={clsx(classes.root)}>
			<DataTable
				id="anrNbrTrackingTable"
				title="Last 15 days changes"
				data={data}
				columns={_getTableColumns()}
				rowsPerPage={10}
				tableBodyMaxHeight="30em"
				tableBodyCellMaxWidth="250"
			/>
		</div>
	);
};

AnrNbrTrackingTable.propTypes = {
	data: PropTypes.array.isRequired
};

export default AnrNbrTrackingTable;
